module.exports = __webpack_public_path__ + "img/zd1_mb.62d5b377.jpg";